import React, { Suspense } from 'react';
import Timestamp from '../../components/Timestamp';
import * as styles from './SlackMessage.module.scss';
import { gql } from '../../graphql/generated/gql';
import type { DocumentType } from '../../graphql/generated/gql';

const DeltaPreview = React.lazy(() => import('../../components/DeltaPreview'));

const SLACK_MESSAGE_FRAGMENT = gql(`
  fragment SlackMessage_message on SlackMessage {
    delta
    ts
    # eslint-disable-next-line @graphql-eslint/require-selections
    user {
      name
      profile {
        avatar
      }
    }
  }
`);

interface SlackMessageProps {
  message: DocumentType<typeof SLACK_MESSAGE_FRAGMENT>;
}

// TODO - show reactions & emoji
const SlackMessage = ({ message: { delta, ts, user } }: SlackMessageProps) => (
  <div className={styles.message}>
    {user?.profile?.avatar && (
      <img className={styles.avatar} src={user.profile.avatar} alt="" />
    )}
    <div className={styles.content}>
      <div className={styles.header}>
        <div className={styles.user}>{user?.name}</div>
        {ts && (
          <div className={styles.timestamp}>
            <Timestamp date={parseInt(ts, 10) * 1000} />
          </div>
        )}
      </div>
      {!!delta && (
        <Suspense fallback={null}>
          <DeltaPreview
            content={delta}
            typography="searchResult"
            maxLines={8}
          />
        </Suspense>
      )}
    </div>
  </div>
);

export default SlackMessage;
